import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { SET_LAST_INPUT_CHANGE_RECORD, SET_SERIES_STORE, SET_SERIES_TYPE_DISABLE_FLAG, SET_VERTICAL_INPUT, SelecrSeriesStore, SelectActiveSeriesIndex, SelectActiveSeriesPartIndex, SelectIsMulti, SelectLastInputChangeRecord, SelectPreviewsActiveSeriesIndex, SelectSeriesPart, SelectSeriesType, SelectSeriesTypeDisableFlag, SelectVerticalInput, SelectboxValue } from '../../../../redux/1d-slice/seriesSlice1d'
import SeriesNumberInput from './SeriesNumberInput'

function VerticalInputContainer({ verticalInputaRefs, inputRefs, horizontalInputRefs, setActiveInput, verticalChangeFn,
    setVerticalChange
    , isMobile, activeButtonValue }) {
    const dispatch = useDispatch()
    let verticalInput = useSelector(SelectVerticalInput)
    let seriesStore = useSelector(SelecrSeriesStore)
    let activeSeriesIndex = useSelector(SelectActiveSeriesIndex)
    let activeSeriesPartIndex = useSelector(SelectActiveSeriesPartIndex)
    let lastInputChangeRecord = useSelector(SelectLastInputChangeRecord)
    let selectSeriesPart = useSelector(SelectSeriesPart)
    let previewActiveSeriesIndex = useSelector(SelectPreviewsActiveSeriesIndex)
    let seriesType = useSelector(SelectSeriesType)
    let seriesTypeDisableFlag = useSelector(SelectSeriesTypeDisableFlag)
    let isMulti = useSelector(SelectIsMulti);

    const [count, setCount] = useState(0)
    const [inputFocus, setInputFocus] = useState(null)
    const [boxGropupIndex, setBoxGropupIndex] = useState(null)

    // create input arrays
    let seriesField = useMemo(() => {
        let newSeriesField = [];
        let seriesField = [...seriesStore[activeSeriesIndex].seriesAllfield[activeSeriesPartIndex]];

        while (seriesField.length) {
            let sliceData = seriesField.splice(0, 10);
            newSeriesField.push(sliceData);
        }
        return newSeriesField;
    }, [activeSeriesIndex, activeSeriesPartIndex, count])

    // update value input change ######################################
    useEffect(() => {
        // check input value condition
        if (lastInputChangeRecord.input) {
            for (let index = 0; index < 3; index++) {
                seriesStore[index].AllSeriesPartName.map((seriesPartName, seriesPartNameIndex) => {
                    if (seriesPartName.active) {
                        updateValue(index, seriesPartNameIndex, lastInputChangeRecord.input)
                    }
                })
            }
            dispatch(SET_SERIES_STORE(seriesStore))
        }
        return () => { }
    }, [lastInputChangeRecord])

    // update value preview series ******************************************
    useEffect(() => {
        let { lastSeriesIndex, lastSeriesPartIndex, isActiveSeriesName } = previewActiveSeriesIndex
        if (lastSeriesIndex !== null && lastSeriesPartIndex !== null) {
            let seriesNameIsActive = seriesStore[activeSeriesIndex].AllSeriesPartName[activeSeriesPartIndex].active //get activr flag
            let previewField = seriesStore[lastSeriesIndex].seriesAllfield[lastSeriesPartIndex]
            let activeField = seriesStore[activeSeriesIndex].seriesAllfield[activeSeriesPartIndex]

            if (lastSeriesIndex !== activeSeriesIndex && selectSeriesPart[activeSeriesIndex]) { //condition 1
                seriesStore[activeSeriesIndex].AllSeriesPartName.map((seriesPartName, seriesPartNameIndex) => {
                    if (seriesPartName.active) {
                        for (let index = 0; index < previewField.length; index++) {
                            if (previewField[index].value) {
                                seriesStore[activeSeriesIndex].seriesAllfield[seriesPartNameIndex][index].setValue(previewField[index].value)
                            }
                            if (previewField[index].horigetalValue) {
                                seriesStore[activeSeriesIndex].seriesAllfield[seriesPartNameIndex][index].setHorigentalValue(previewField[index].horigetalValue)
                            }
                            if (previewField[index].verticalValue) {
                                seriesStore[activeSeriesIndex].seriesAllfield[seriesPartNameIndex][index].setVerticalValue(previewField[index].verticalValue)
                            }
                        }
                    }
                })
                dispatch(SET_SERIES_STORE(seriesStore))
                setCount(count + 1)
            } else if (lastSeriesIndex === activeSeriesIndex && selectSeriesPart[activeSeriesIndex]) { //condition 2
                seriesStore[activeSeriesIndex].AllSeriesPartName.map((seriesPartName, seriesPartNameIndex) => {
                    if (seriesPartName.active) {
                        for (let index = 0; index < previewField.length; index++) {
                            if (previewField[index].value) {
                                seriesStore[activeSeriesIndex].seriesAllfield[seriesPartNameIndex][index].setValue(previewField[index].value)
                            }
                            if (previewField[index].horigetalValue) {
                                seriesStore[activeSeriesIndex].seriesAllfield[seriesPartNameIndex][index].setHorigentalValue(previewField[index].horigetalValue)
                            }
                            if (previewField[index].verticalValue) {
                                seriesStore[activeSeriesIndex].seriesAllfield[seriesPartNameIndex][index].setVerticalValue(previewField[index].verticalValue)
                            }
                        }
                    }
                })

                dispatch(SET_SERIES_STORE(seriesStore))
                setCount(count + 1)
            } else if (lastSeriesPartIndex !== activeSeriesPartIndex && seriesNameIsActive) { //condition 3 seriespart name is active

                for (let index = 0; index < previewField.length; index++) {
                    if (previewField[index].value) {
                        activeField[index].setValue(previewField[index].value)
                    }
                    if (previewField[index].horigetalValue) {
                        activeField[index].setHorigentalValue(previewField[index].horigetalValue)
                    }
                    if (previewField[index].verticalValue) {
                        activeField[index].setVerticalValue(previewField[index].verticalValue)
                    }
                }
                dispatch(SET_SERIES_STORE(seriesStore))
                setCount(count + 1)
            }
        }

    }, [previewActiveSeriesIndex])

    let updateValue = (SeriesIndex, seriesPartNameIndex, input) => {
        if (Array.isArray(input)) {
            input.map((field) => {
                seriesStore[SeriesIndex].seriesAllfield[seriesPartNameIndex][field.index].setValue(field.value);
                seriesStore[SeriesIndex].seriesAllfield[seriesPartNameIndex][field.index].setHorigentalValue(field.horigetalValue);
                seriesStore[SeriesIndex].seriesAllfield[seriesPartNameIndex][field.index].setVerticalValue(field.verticalValue);
            })
        } else {
            seriesStore[SeriesIndex].seriesAllfield[seriesPartNameIndex][input.index].setValue(lastInputChangeRecord.input.value);
            seriesStore[SeriesIndex].seriesAllfield[seriesPartNameIndex][input.index].setHorigentalValue(lastInputChangeRecord.input.horigetalValue);
            seriesStore[SeriesIndex].seriesAllfield[seriesPartNameIndex][input.index].setVerticalValue(lastInputChangeRecord.input.verticalValue);
        }
    }

    let inputChange = (value, index) => {
        let number = 0;
        let inputArray = [];

        // loop through current 10-block
        for (let i = index * 10; i < ((index * 10) + 10); i += 1) {
            let field = seriesStore[activeSeriesIndex].seriesAllfield[activeSeriesPartIndex][i];
            number += 1;

            if (seriesType === 'Even') {
                if (!seriesTypeDisableFlag) {
                    dispatch(SET_SERIES_TYPE_DISABLE_FLAG(true));
                }
                if (number % 2 !== 0) {
                    field.setVerticalValue(value || 0);
                    inputArray.push(field);
                }
            } else if (seriesType === 'Odd') {
                if (!seriesTypeDisableFlag) {
                    dispatch(SET_SERIES_TYPE_DISABLE_FLAG(true));
                }
                if (number % 2 === 0) {
                    field.setVerticalValue(value || 0);
                    inputArray.push(field);
                }
            } else {
                field.setVerticalValue(value || 0);
                inputArray.push(field);
            }
        }

        // ✅ If multi-select → apply to ALL checked series parts
        if (isMulti) {
            seriesStore[activeSeriesIndex].AllSeriesPartName.forEach((part, partIdx) => {
                if (part.active && partIdx !== activeSeriesPartIndex) {
                    inputArray.forEach((field, j) => {
                        seriesStore[activeSeriesIndex].seriesAllfield[partIdx][field.index].setVerticalValue(field.verticalValue);
                    });
                }
            });
        }

        let updateVerticalValue = [...verticalInput];
        updateVerticalValue[index] = value;
        dispatch(SET_VERTICAL_INPUT(updateVerticalValue));
        dispatch(
            SET_LAST_INPUT_CHANGE_RECORD({
                activeSeriesIndex,
                activeSeriesPartIndex,
                input: inputArray
            })
        );
        return inputArray;
    };

    let verticalInputFocusChange = (e, i) => {
        let { key } = e
        if (key === 'ArrowUp') {
            verticalInputaRefs.current[i - 1]?.focus();
        } else if (key === 'ArrowDown') {
            verticalInputaRefs.current[i + 1]?.focus();
        } else if (key === 'ArrowRight') {
            if (seriesType === 'Odd') {
                inputRefs.current[i > 0 ? (i * 10 + 1) : i + 1]?.focus();
            } else {
                inputRefs.current[i > 0 ? i * 10 : i]?.focus();
            }
        } else if (key === 'ArrowLeft') {
            if (i > 0) {
                if (seriesType === 'Even') {
                    inputRefs.current[(i * 10 - 2)]?.focus();
                } else {
                    inputRefs.current[(i * 10 - 1)]?.focus();
                }
            }
        }
    }

    useEffect(() => {
        if (setVerticalChange) {
            setVerticalChange(() => (value, index) => {
                return inputChange(value, index); // ✅ return
            });
        }
    }, [activeSeriesIndex, activeSeriesPartIndex, seriesType, isMulti]);
    // console.log(verticalInput,'verticalInput2d')

    return (
        <>
        <React.Fragment>
            {verticalInput.map((value, index) => {
                return (
                    <tr  key={index}>
                        <td key={index} >
                                <input
                                    style={{ height:"30px", width:'100%',   backgroundColor:'#c0504c',textAlign: 'center', 
                                        border: '1px solid #000', }}
                                    type="text"
                                    className=""
                                    value={value || ""}
                                    onChange={(e) => {
                                        if (
                                            +e.target.value > 0 &&
                                            e.target.value.length <= 3
                                        ) {
                                            inputChange(Number(e.target.value), index);
                                        } else {
                                            if (!e.target.value) {
                                                inputChange("", index);
                                            }
                                        }
                                    }}
                                    placeholder={index === 0 ? `${index}X` : `${index}X`}
                                    ref={(el) => (verticalInputaRefs.current[index] = el)}
                                    onFocus={(e) => {
                                        setActiveInput({ type: "vertical", index });

                                        const el = verticalInputaRefs.current[index];
                                        el?.select();

                                        // ⭐ value add
                                        if (isMobile && activeButtonValue) {
                                            const currentVal = Number(value) || 0;
                                            const newVal = currentVal + Number(activeButtonValue);

                                            inputChange(newVal, index);
                                        }

                                        // ⭐ IMPORTANT: focus remove karo (same as SeriesNumberInput)
                                        // setTimeout(() => {
                                        //     el?.blur();
                                        //     setActiveInput(null);
                                        // }, 50);
                                    }}
                                    onKeyDown={(e) => {
                                        const regex = new RegExp(
                                            /(^\d*$)|(Backspace|Tab|Delete|ArrowLeft|ArrowRight)/
                                        );
                                        if (!e.key.match(regex) && e.preventDefault()) {
                                            e.preventDefault();
                                        }
                                    }}
                                    onClick={(e) => {
                                        e.target.select();
                                    }}
                                    onKeyUp={(e) => {
                                        e.stopPropagation();
                                        verticalInputFocusChange(e, index);
                                    }}
                                     readOnly={isMobile}
                                />
                            {/*  */}
                        {/*  */}
                        </td>

                        <SeriesNumberInput
                            seriesField={seriesField[index]}
                            inputRefs={inputRefs}
                            horizontalInputRefs={horizontalInputRefs}
                            verticalInputaRefs={verticalInputaRefs}
                            inputFocus={inputFocus}
                            setActiveInput={setActiveInput}
                            setInputFocus={setInputFocus}
                            boxGropupIndex={boxGropupIndex}
                            setBoxGropupIndex={setBoxGropupIndex}
                               activeButtonValue={activeButtonValue}
                                isMobile={isMobile}
                        />
                    </tr>
                );
            })}
        </React.Fragment>
        </>
    )
}

export default VerticalInputContainer